// extracted by mini-css-extract-plugin
export default {"bar":"GroupedVerticalBar_bar__W-bgu"};